export const dateToFileFormat = (date) => {
  //01-11-2023 15:50:30 -> 20231101_155030
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const monthString = month < 10 ? `0${month}` : `${month}`;
  const dayString = day < 10 ? `0${day}` : `${day}`;
  const hoursString = hours < 10 ? `0${hours}` : `${hours}`;
  const minutesString = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondsString = seconds < 10 ? `0${seconds}` : `${seconds}`;

  return `${year}${monthString}${dayString}_${hoursString}${minutesString}${secondsString}`;
};

export const dateToHumanReadableFormat = (date) => {
  //01-11-2023 15:50:30 -> Miércoles, 1 de Noviembre de 2023, 15:50:30

  const day = date.getDate();
  const year = date.getFullYear();

  const dayString = day < 10 ? `0${day}` : `${day}`;

  const dayName = date.toLocaleDateString('es-ES', { weekday: 'long' });
  const monthName = date.toLocaleDateString('es-ES', { month: 'long' });

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const hoursString = hours < 10 ? `0${hours}` : `${hours}`;
  const minutesString = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondsString = seconds < 10 ? `0${seconds}` : `${seconds}`;

  return `${dayName}, ${dayString} de ${monthName} de ${year}, ${hoursString}:${minutesString}:${secondsString}`;
};

export const dateToTimeSince = (date) => {
  const seconds = Math.floor((new Date() - date) / 1000);
  let interval = seconds / 31536000;

  const print = (interval, unit_singular, unit_plural) =>
    `Hace ${Math.floor(interval)} ${Math.floor(interval) === 1 ? unit_singular : unit_plural}`;

  if (interval > 1) {
    return;
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return print(interval, 'mes', 'meses');
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return print(interval, 'día', 'días');
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return print(interval, 'hora', 'horas');
  }
  interval = seconds / 60;
  if (interval > 1) {
    return print(interval, 'minuto', 'minutos');
  }
  return print(seconds, 'segundo', 'segundos');
};

export const dateRangeToMonthYear = (since, until) => {
  const listaFechas = [];
  const currentDate = new Date(since);
  const endDate = new Date(until);
  endDate.setMonth(endDate.getMonth() + 1);

  while (currentDate <= endDate) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // Los meses van de 0 a 11, por lo que sumamos 1
    listaFechas.push(`${month}/${year}`);

    // Incrementa la fecha al primer día del siguiente mes
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return listaFechas;
};

//Date -> YYYY-MM-DD
export const dateRangeToMachineString = (since, until) => {
  const dateArray = [];
  const currentDate = new Date(until);

  while (currentDate >= since) {
    dateArray.push(formatDate(currentDate));
    currentDate.setDate(currentDate.getDate() - 1);
  }

  return dateArray;
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
